import styled from 'styled-components';

export const Content = styled.input`
  border-radius: 10px;
  border: solid 1px #3d4952;
  background-color: #10151a;
  width: 100%;
  height: 48px;
  font-size: 20px;
  color: #e6eaec;
  outline: none;
  padding: 0 15px;
  box-sizing: border-box;
  text-align: left;
  transition:
    border-color 0.15s ease,
    box-shadow 0.15s ease;

  font-family: 'IBM Plex Mono', monospace;
  font-variant-numeric: tabular-nums slashed-zero;

  &::placeholder {
    color: #5a666d;
  }
  &:focus {
    border-color: #47b972;
    box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.16);
  }
  &[disabled] {
    color: #7a838a;
    background-color: #12181c;
    border-color: #2c353d;
  }

  &.size-sm {
    height: 34px;
    font-size: 15px;
  }
`;
